import { render, staticRenderFns } from "./AdminOfficeDetailsView.vue?vue&type=template&id=8db1046a&scoped=true&"
import script from "./AdminOfficeDetailsView.vue?vue&type=script&lang=js&"
export * from "./AdminOfficeDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminOfficeDetailsView.vue?vue&type=style&index=0&id=8db1046a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db1046a",
  null
  
)

export default component.exports